export default __webpack_public_path__ + "static/hero-img-e41065327ad54da9c36aeab928c08973.png";